import { v4 as uuid } from "uuid";
import mapKnownValues from "../../utils/mapKnownValues";

export enum Role {
  Admin = "ADMIN",
  User = "USER",
}

export enum InviteStatus {
  pending = "PENDING",
  approved = "CONFIRMED",
}

export type UserAPIResponse = {
  editPermission: boolean;
  firstName: string;
  inviteStatus: InviteStatus;
  lastName: string;
  phoneNumber: string;
  role: Role;
  tenantId: number;
  email: string;
  userDetailsId: number;
  workEmail: string;
};

export default class User {
  editPermission = false;
  emailVerified = false;
  firstName = "";
  inviteStatus = InviteStatus.pending;
  lastName = "";
  phoneNumber = "";
  role = Role.Admin;
  tenantId = -1;
  userDetailsId = -1;
  workEmail = "";
  companyName = ""; // Added after the call
  readonly uid = uuid();
  _originalData = "";

  constructor(params: Partial<User> = {}) {
    mapKnownValues(this, { ...params });
    if (!params?._originalData) {
      this._originalData = JSON.stringify({
        ...this,
        _originalData: undefined,
      });
    }
  }

  get initials() {
    return `${this.firstName.charAt(0)}${this.lastName.charAt(0)}`.toUpperCase();
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  get hasChanged() {
    return (
      JSON.stringify({
        ...this,
        _originalData: undefined,
      }) !== this._originalData
    );
  }

  get roleDisplay() {
    let role = "Administrator";
    if (this.inviteStatus === InviteStatus.pending) {
      role += " (Invite pending)";
    }
    return role;
  }

  toJSONForAPI() {
    return JSON.stringify({
      ...this,
      uid: undefined,
      _originalData: undefined,
      tenantId: this.tenantId > -1 ? this.tenantId : undefined,
      userDetailsId: this.userDetailsId > -1 ? this.userDetailsId : undefined,
    });
  }

  static fromAPI(userResponse: UserAPIResponse & { companyName?: string }) {
    return new User(userResponse);
  }
}
